import { getColor } from 'common/constants/_colors';
import { WhiteSection } from 'components/base/layout-components';
import styled from 'styled-components';
import { StyledSelectedFilters } from './CategoryStats/CategoryFilters/CategoryFilters.style';
import { Link } from '@material-ui/core';

export const StyledHorizontalList = styled.ul`
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  margin-top: 1rem;
  & > li {
    &:not(:last-child) {
      margin-right: 1rem;
      padding-right: 1rem;
      border-right: 1px solid #aaa;
    }
  }
`;

export const StyledDescriptionLink = styled(Link)`
  color: ${getColor('dodgerBlue')};
  font-size: 1.2rem;
  &:hover {
    opacity: 0.7;
  }
`;

export const StyledSelectedCategory = styled.div`
  position: relative;
  & ${WhiteSection} {
    height: 100%;
  }
  & ${StyledSelectedFilters} {
    margin-top: 3rem;
  }
`;
